import React from "react";
import "./index.scss";
import { Form, Input, Checkbox, Row, Col } from "antd";
import TextArea from "antd/es/input/TextArea";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";

const Contact = () => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      await emailjs.send(
        "service_xmh34ms",
        "template_k3c533y",
        values,
        "BqNE-tYYcOgAR2YXE"
      );

      form.resetFields();
      alert("Message Sent Successfully!");
    } catch (error) {
      alert("Error While sending Message!");
      console.error(error);
    }
  };

  return (
    <div className="contact-main">
      {/* Banner */}
      <div id="banner-area">
        <div className="about-overlay"></div>
        <div className="banner-title-content">
          <h2>Contact Us</h2>
        </div>
      </div>

      <div className="form-container">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          
          {/* Row: Name, Email, Phone */}
          <Row gutter={[16, 16]}>
            <Col xs={24} md={8}>
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter your name" },
                  {
                    pattern: /^[a-zA-Z ]{2,50}$/,
                    message: "Enter valid name",
                  },
                ]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Enter valid email" },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
              <Form.Item
                label="Phone"
                name="phone"
                rules={[
                  { required: true, message: "Please enter phone number" },
                  {
                    pattern: /^[6-9]\d{9}$/,
                    message: "Enter valid 10-digit number",
                  },
                ]}
              >
                <Input placeholder="Enter phone number" />
              </Form.Item>
            </Col>
          </Row>

          {/* Message */}
          <Form.Item
            label="Message"
            name="message"
            rules={[
              { required: true, message: "Please enter message" },
              { min: 10, message: "Message should be at least 10 characters" },
            ]}
          >
            <TextArea rows={4} placeholder="Write your message..." />
          </Form.Item>

          <div className="terms-title">Terms of Service</div>

          {/* Terms */}
          <Form.Item
            name="terms"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(new Error("You must accept the terms")),
              },
            ]}
          >
            <Checkbox>
              By providing your phone number, you agree to receive Promotional
              text messages from Computer Data Concepts. Message & data rates
              may apply{" "}
              <span className="terms-btn" >
              <Link to="/termnconditions">Terms and Conditions</Link>
              </span>
              .
            </Checkbox>
          </Form.Item>

          <button className="submit-btn" htmlType="submit">
            Send Message
          </button>
        </Form>
      </div>
    </div>
  );
};

export default Contact;